export default __webpack_public_path__ + "static/pattern-254fb0063e2362e3e7b5bd79c2d548e8.svg";